"use strict";
// Who may call a method: the vocabulary each definition's `access` is written in, and the one rule that reads it.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccessGranted = exports.accessDenial = exports.meetsAccessLevel = exports.hasOAuthScope = exports.oauthScopeFor = void 0;
// Permissions that grant anything at all; the string 'null' is the bottom of getLeastPermission's scale and grants nothing.
const GRANTED_PERMISSIONS = ['view', 'boost_snooze', 'edit', 'admin', 'owner'];
const oauthScopeFor = (access) => `gateway:${access.level}`;
exports.oauthScopeFor = oauthScopeFor;
// Exact membership, as oAuthmodel.verifyScope checks it: gateway:admin does not stand in for gateway:view.
const hasOAuthScope = (access, scopes) => {
    const granted = typeof scopes === 'string' ? scopes.split(/[\s,]+/) : scopes || [];
    return granted.indexOf((0, exports.oauthScopeFor)(access)) !== -1;
};
exports.hasOAuthScope = hasOAuthScope;
// betazoid's isAllowed without its god shortcut at view: view is any granted permission, edit is edit or admin, admin is exactly admin.
const meetsAccessLevel = (level, permission) => {
    switch (level) {
        case 'view':
            return typeof permission === 'string' && GRANTED_PERMISSIONS.indexOf(permission) !== -1;
        case 'edit':
            return permission === 'edit' || permission === 'admin';
        case 'admin':
            return permission === 'admin';
        default:
            return false;
    }
};
exports.meetsAccessLevel = meetsAccessLevel;
// god is checked last and only ever adds a requirement; it never stands in for a missing scope or permission.
const accessDenial = (access, caller) => {
    if (!(0, exports.hasOAuthScope)(access, caller.scopes))
        return 'SCOPE';
    if (!(0, exports.meetsAccessLevel)(access.level, caller.gatewayPermission))
        return 'PERMISSION';
    if (access.god === true && caller.god !== true)
        return 'GOD';
    return null;
};
exports.accessDenial = accessDenial;
const isAccessGranted = (access, caller) => (0, exports.accessDenial)(access, caller) === null;
exports.isAccessGranted = isAccessGranted;
